import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { QueryProvider } from "./providers/QueryProvider";
import {
  LazyStatisticsPage,
  LazyRecordsPage,
  LazySubmitMisconductCase,
  LazyJusticeMapPage,
  withLazyLoading,
} from "./components/common/LazyComponents";
import theme from "./theme";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/common/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import SubmitCase from "./pages/SubmitCase";
import SubmitSourceMaterials from "./pages/SubmitSourceMaterials";
import Method from "./pages/Method";
import Contact from "./pages/Contact";

// Wrap lazy components with error boundaries and loading states
const EnhancedStatisticsPage = withLazyLoading(
  LazyStatisticsPage,
  "Loading statistics dashboard..."
);
const EnhancedRecordsPage = withLazyLoading(
  LazyRecordsPage,
  "Loading records..."
);
const EnhancedSubmitMisconductCase = withLazyLoading(
  LazySubmitMisconductCase,
  "Loading form..."
);
const EnhancedJusticeMapPage = withLazyLoading(
  LazyJusticeMapPage,
  "Loading Judicial Agency Map..."
);

const AppContent = () => (
  <Router>
    <ScrollToTop />
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/submit-case" element={<SubmitCase />} />
        <Route path="/submit-source" element={<SubmitSourceMaterials />} />
        <Route path="/method" element={<Method />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/map" element={<EnhancedJusticeMapPage />} />
        <Route path="/agencies" element={<Navigate to="/map" replace />} />
        {/* Legacy routes for backwards compatibility */}
        <Route path="/submit-misconduct" element={<SubmitCase />} />
        {/* <Route path="/records" element={<EnhancedRecordsPage />} /> */}
        {/* <Route path="/statistics" element={<EnhancedStatisticsPage />} /> */}
      </Routes>
    </Layout>
  </Router>
);

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <QueryProvider>
      <AppContent />
    </QueryProvider>
  </ThemeProvider>
);

export default App;